<div *ngIf="mainPageLoader" class="loading-shade">
    <div class="loader" alt="Please wait..."></div>
</div>
<div *ngIf="!mainPageLoader" style="position: relative;">
    <div class="container-fluid d-flex align-items-center justify-content-center" style="position: fixed; top: 0; bottom: 0; left: 0; right: 0; background-color: #707070;">
        <div class="row m-0 d-flex justify-content-center">
            <div *ngIf="!hideForm && !apiFailMsg" class="col-12 col-md-7 col-lg-5 col-xl-4 feedback_wrapper">
                <form [formGroup]="docsFeedbackForm" (ngSubmit)="onSubmitForm()">
                    <div class="row m-0">
                        <div class="col-12 mb-3">
                            <p class="mb-1 font_size" style="font-weight: bold;">
                                <span style="color: #da291c;">*</span>&nbsp;
                                <label for="userName">{{ 'yourName' | translate }}</label>
                            </p>
                            <input id="userName" type="text" formControlName="name" class="form-control input_font text_field" placeholder="{{ 'pleaseProvideName' | translate }}" required />
                        </div>
                        <div class="col-12 mb-3">
                            <p class="mb-1 font_size" style="font-weight: bold;">
                                <span style="color: #da291c;">*</span>&nbsp;
                                <label for="userEmail">{{ 'yourEmail' | translate }}</label>
                            </p>
                            <input id="userEmail" type="email" formControlName="email" [ngClass]="{'disableField': disableField}" class="form-control input_font text_field" placeholder="{{ 'pleaseProvideEmail' | translate }}" required />
                        </div>
                        <div class="col-12 mb-3">
                            <p class="mb-1 font_size" style="font-weight: bold;">
                                <span style="color: #da291c;">*</span>&nbsp;
                                <label for="userCategory">{{ 'category' | translate }}</label>
                            </p>
                            <select id="userCategory" formControlName="category" class="form-control input_font text_field" required>
                                <option value="" selected disabled>{{ 'pleaseSelectOpt' | translate }}</option>
                                <option *ngFor="let opt of categoryOptionsArr" [value]="opt.val">{{ opt.key }}</option>
                            </select>
                        </div>
                        <div class="col-12 mb-3">
                            <p class="mb-1 font_size" style="font-weight: bold;">
                                <span style="color: #da291c;">*</span>&nbsp;
                                <label for="userLink">{{ 'url' | translate }}</label>
                            </p>
                            <input id="userLink" type="text" formControlName="url" class="form-control input_font text_field" placeholder="{{ 'pleaseProvideURL' | translate }}" required />
                        </div>
                        <div class="col-12 mb-3">
                            <p class="mb-1 font_size" style="font-weight: bold;">
                                <span style="color: #da291c;">*</span>&nbsp;
                                <label for="userDescription">{{ 'description' | translate }}</label>
                            </p>
                            <textarea id="userDescription" formControlName="description" class="form-control input_font text_field" placeholder="{{ 'pleaseProvideDescript' | translate }}"></textarea>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn submit_btn" [disabled]="!docsFeedbackForm.valid">{{ 'OneCareSubmit' | translate }}</button>
                        </div>
                    </div>
                </form>
            </div>
            <div *ngIf="hideForm" class="col-12 bg-white text-center" style="padding: 20px; border-radius: 10px;">
                <p><mat-icon style="color: dodgerblue;" aria-hidden="false">thumb_up</mat-icon></p>
                <p>{{ 'thankYouForFeedback' | translate }}.</p>
                <p>{{ 'closeThisPage' | translate }}.</p>
            </div>
            <div *ngIf="apiFailMsg" class="col-12 bg-white text-center" style="padding: 20px; border-radius: 10px;">
                <p><mat-icon style="color: #da291c;" aria-hidden="false">cancel</mat-icon></p>
                <p>{{ 'somethingWentWrong' | translate }}!</p>
                <p>{{ 'pleaseContactAdminCust' | translate }}.</p>
            </div>
        </div>
    </div>
</div>